import { render, staticRenderFns } from "./MyComent.vue?vue&type=template&id=bc51aaf0&scoped=true"
import script from "./MyComent.vue?vue&type=script&lang=js"
export * from "./MyComent.vue?vue&type=script&lang=js"
import style0 from "./MyComent.vue?vue&type=style&index=0&id=bc51aaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc51aaf0",
  null
  
)

export default component.exports